import React from "react";
import { toast } from "react-toastify";
import apiClient from "../../../../application/apis/tenant-management/tenant-management-client";
import { UserEntity } from "../../../../application/domain/user/user-entity";
import { reportUnexpectedError } from "../../../../error-reporter";
import { BaseModal } from "../../../atoms/base-modal";
import { ConfirmModalContentForUser } from "./confirm-modal-content-for-user";

type Props = {
  user: UserEntity;
  isActive: boolean;
  onClose: () => void;
  title: string;
};

export const DisableTOTPConfirmModal: React.FC<Props> = ({
  user,
  isActive,
  onClose,
  title,
}) => {
  const [isLoading, setLoading] = React.useState(false);

  const disableTOTP = React.useCallback(async () => {
    setLoading(true);
    try {
      await apiClient.disableTOTPByUserMgr(user.id);
      toast.success("2段階認証を無効化しました");
      onClose();
    } catch (e) {
      reportUnexpectedError(e);
      toast.error("2段階認証の無効化に失敗しました");
    } finally {
      setLoading(false);
    }
  }, [user.id, setLoading]);

  return (
    <BaseModal isActive={isActive} title={title} onClose={onClose}>
      {user.isTOTPEnabled() ? (
        <ConfirmModalContentForUser
          user={user}
          confirmMessage={
            <h2>
              以下のアカウントの2段階認証を無効化し、組織コード、アカウント名、パスワードのみでログインできるようにします。
            </h2>
          }
          submitLabel="2段階認証設定を無効化"
          onSubmit={disableTOTP}
          cancelLabel="キャンセルする"
          onCancel={onClose}
          isLoading={isLoading}
        />
      ) : (
        <>
          <section className="modal-card-body">
            <div className="field">
              <h2>このユーザーは2段階認証を設定していません。</h2>
            </div>
          </section>
          <section className="modal-card-foot">
            <button
              type="button"
              className="button is-fullwidth"
              onClick={onClose}
            >
              モーダルを閉じる
            </button>
          </section>
        </>
      )}
    </BaseModal>
  );
};
